import React, { useContext, useEffect } from "react";
import axios from "axios";
import { BrowserRouter, HashRouter, Route, Switch } from "react-router-dom";
import Header from "./Header";
import Overview from "./Overview";
import AccountHistory from "./Account_History";
import Footer from "./Footer";
import { StateContext } from "../App";
import Deposit from './Deposit'
import Withdraw from './Withdraw'
import Security from './Security'
import Invoice from './Invoice'
import Notification from './Notification'

function Dashboard(props) {
  const { state, dispatch } = useContext(StateContext);


    // Authenticate the App First!
  // Server does the Bouncing
  useEffect(() => {
    dispatch({type: 'SET_LOADING', payload: true});

    axios.get("/verify-cookie")
      .then((result) => {
      // console.log("cookie Verification", result.data.redirect);
      if (result.data.redirect) {
        alert("Session expired, Please login!")
        dispatch({type: 'SET_LOADING', payload: false});
        window.location.assign(result.data.redirect);
      }
     
    });
  }, []);

  // Get The User now!
  useEffect(() => {
    const userId = JSON.parse(localStorage.getItem("user")) || null;
    // alert(`i have the user--- ${userId}`)

    userId && axios.get(`/admin/customer/${userId}`)
    .then((result) => {
      // console.table(result.data);

      // You can Now dispatch
      // this data to the App State!
      // On condition.
      if (!result.data.redirect) {
        dispatch({ type: "SET_USER", payload: result.data.customer })
        dispatch({ type: "SET_LOADING", payload: false })
      } else {
        window.location.assign(result.data.redirect);
      };
    }).catch(err => {
      console.log('Err Ocuured!')
      dispatch({ type: "SET_LOADING", payload: false })
    })
  }, [])


  return (
    <div className="App">
      <Header state={state} dispatch={dispatch} />
      <HashRouter>
        <Route path="/dashboard/overview" component={Overview} />
        <Route path="/dashboard/overview" component={AccountHistory} />
        <Route path="/dashboard/deposit" component={Deposit} />
        <Route path="/dashboard/withdraw" component={Withdraw} />
        <Route path="/dashboard/security" component={Security} />
        <Route path="/dashboard/invoice" component={Invoice} />
        <Route path="/dashboard/notifications" component={Notification} />
      </HashRouter>
      <Footer />
    </div>
  );
}

export default Dashboard;
